import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LuMenu, LuX } from "react-icons/lu";
import './Navbar.css';
import logo from '../assets/logo_master.png'
import logoHover from '../assets/logo_master_F2E6F7.png'

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="nav-content">
          <Link to="/" className="nav-brand logo-swap" onClick={closeMenu}>
            {/* Base */}
            <img
              src={logo}
              alt="Psicología Em Gamarro, Emily Gamarro"
              className="logo-base"
              loading="eager"
              decoding="async"
            />
            {/* Hover */}
            <img
              src={logoHover}
              alt="Psicología Em Gamarro, Emily Gamarro"
              className="logo-hover"
              loading="eager"
              decoding="async"
            />
          </Link>

          <ul className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}>
            <li className="nav-item">
              <Link
                to="/"
                className={`nav-link ${isActive('/') ? 'nav-link-active' : ''}`}
                onClick={closeMenu}
              >
                Inicio
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/about"
                className={`nav-link ${isActive('/about') ? 'nav-link-active' : ''}`}
                onClick={closeMenu}
              >
                Sobre Mí
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/services"
                className={`nav-link ${isActive('/services') ? 'nav-link-active' : ''}`}
                onClick={closeMenu}
              >
                Servicios
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/contact"
                className={`nav-link ${isActive('/contact') ? 'nav-link-active' : ''}`}
                onClick={closeMenu}
              >
                Contacto
              </Link>
            </li>
          </ul>

          <button
            className="nav-toggle"
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            {isMenuOpen ? <LuX size={24} /> : <LuMenu size={24} />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;